import { useTranslation } from "react-i18next";
import { CircleAlert } from "lucide-react";
import MessageTracking from "./MessageTracking";
import MessageDetail from "./MessageDetail";

const MessageOverview = ({ eventData }) => {
  const { t } = useTranslation();

  if (!eventData) return null;

  // const { data, isLoading } = useQuery({
  //   queryKey: ["message-thread", eventData.threadId],
  //   queryFn: () => getMessageThread(eventData.threadId),
  //   enabled: !!eventData.threadId,
  //   staleTime: 60 * 1000, // cache 60s
  // });

  // const messageThreads = fromJS(data?.content || []);

  const renderTracking = () => {
    if (eventData.tracking) {
      return (
        <MessageTracking
          trackingId={eventData.messageId}
          hasGmail={eventData.hasGmail}
          hasOutlook={eventData.hasOutlook}
        />
      );
    } else {
      return (
        <div className="w-full inline-flex items-center space-x-1 bg-yellow-200 text-yellow-90 rounded-lg">
          <CircleAlert className="h-4 w-4 text-yellow-900" aria-hidden="true" />
          <div className="text-yellow-900">
            {t("Hint: Turn on email tracking when sending new email to receive tracking infos")}
          </div>
        </div>
      );
    }
  };

  // if (isLoading) return <div className="w-full justify-items-center"><SmallLoading /></div>;

  return (
    <>
      {renderTracking()}
      <div className="w-full p-4 rounded-lg shadow-sm border border-gray-200 space-y-4">
        <div className="text-lg font-semibold">{eventData.summary || "No Subject"}</div>
        <MessageDetail eventData={eventData} />
      </div>
    </>
  );
};

export default MessageOverview;
